import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../modules/shared.module';
import {AppColoredLabelComponent} from './app-colored-label.component';


@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    declarations: [ AppColoredLabelComponent ],
    exports: [ AppColoredLabelComponent ]

})
export class AppColoredLabelModule { }



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/app-colored-label/app-colored-label.module.ts